import { Step } from 'react-joyride'

const widgetConstants = {
  OPTIMIZE_GRID: `optimize`,
  OPTIMIZE_WIDGET_1: `item-1`,
  OPTIMIZE_WIDGET_2: `item-2`,
  OPTIMIZE_WIDGET_3: `item-3`,
}

const resultInfo: Step[] = [
  {
    target: widgetConstants.OPTIMIZE_WIDGET_1,
    content: `The current production plan is displayed here, with an hourly resolution. The production values are given as an hourly mean, for example a MW value with timestamp 08:00 signifies the mean production in the interval 08:00-08:59. If the “show outcome” box is checked, the graph will display one week of historical measured production, followed by the forecasted optimized production plan for one week ahead. Unchecking the “show outcome” box will hide the historical measured production to only show the forecasted production plan. By hovering the chart, hourly values will be displayed for each production unit. It is also possible to zoom in the chart using click-and-drag. If you would like to print or save the chart as an Excel file, PDF or image, it is possible to use the export button at the right hand corner where you also find the chart settings.`,
    title: `Optimization result`,
  },
]
const forecastInfo: Step[] = [
  {
    target: widgetConstants.OPTIMIZE_WIDGET_2,
    content: `The forecast chart gives you the possibility to pick which forcast you would like to inspect during the current production plan period. The forecasts are parts of the production plan calculations.`,
    title: `Optimization forecasts`,
  },
]
const tableInfo: Step[] = [
  {
    target: widgetConstants.OPTIMIZE_WIDGET_3,
    content: `This table shows the data from the chart 'Optimization result' - If no data is displayed here, you need to start a new optimization`,
    title: `Optimization result - table`,
  },
]

const steps: Step[] = [
  {
    target: 'optimize-tours-header',
    content: `The prerequisites allow you to adjust start and end levels of the plants' accumulators (if applicable). Here you will also see any active deviation settings that currently affects your production plan if you choose to start a new optimization. You also have the choice to activate automatic optimizations, which puts optimizations to execute automatically once every hour.`,
    title: `Production plan prerequisites`,
  },
  ...resultInfo,
  ...forecastInfo,
  ...tableInfo,
]

function getTourSteps(tourId: number | null): Step[] {
  if (tourId === 1) {
    return resultInfo
  }

  if (tourId === 2) {
    return forecastInfo
  }

  if (tourId === 3) {
    return tableInfo
  }

  return steps
}

export default {
  widgetConstants,
  resultInfo,
  forecastInfo,
  tableInfo,
  steps,
  getTourSteps,
}
